// extracted by mini-css-extract-plugin
export default {"Mask":"index_Mask__sXBXu","Container":"index_Container__QPhju","Content":"index_Content__80A9E","Btns":"index_Btns__IjRGj","Btn":"index_Btn__QijY+","Ok":"index_Ok__qHgeT"};